import { render, staticRenderFns } from "./SfCircleIcon.vue?vue&type=template&id=5803ce72&functional=true&"
import script from "./SfCircleIcon.vue?vue&type=script&lang=js&"
export * from "./SfCircleIcon.vue?vue&type=script&lang=js&"
import style0 from "./SfCircleIcon.vue?vue&type=style&index=0&id=5803ce72&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports